package com.macrofocus.eflux

import com.macrofocus.eflux.ui.mui.Content
import i18next.ReactI18next.I18nextProvider
import i18next.i18nextInit
import kotlinx.coroutines.MainScope
import react.create
import react.dom.client.createRoot
import web.dom.ElementId
import web.dom.document

val mainScope = MainScope()
//val appDI = koinApplication {
//    modules(AppModule + AppPreferenceModule + module {
//        single { IdolSearchViewModel(get()) }
//        single { PreviewViewModel(get()) }
//    })
//}

/**
 * Main entry point to the EFlux client application
 */
fun main() {
    println("Bootstrapping EFlux")
    val eflux = EFlux()

    println("EFlux starting up")

//    window.onload = {
//        startKoin {
//            modules()
//        }

        createRoot(document.getElementById(ElementId("root"))!!).render(
                I18nextProvider.create {
                    i18n = i18nextInit()

//                Suspense {
//                    asDynamic()["fallback"] = "Loading..."

                    Content {
                        this.eflux = eflux
                    }
//                    KoinAppProvider {
//                        routing(dataLoader, dataLoader.diagramLoaders, diagramTypeProperty)
//                    }
                }
//            }
        )
//    }
}